import { Metadata } from '../../../../utils/spds/metadata';
import Super from '../../core/button.gjs';
import styles from './tertiary.module.scss';

const METADATA = Metadata.define({
  description: `
    Tertiary button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Tertiary Button',
});

export default class SpdsActionButtonTertiary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  hasBorder = true;
  variantClass = 'spds-action-button-tertiary';
  variantStyles = styles;
}

export const ACTION_BUTTON_TERTIARY_METADATA = SpdsActionButtonTertiary.metadata;
